




































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLine } from '@fortawesome/free-brands-svg-icons/faLine';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/faQuestionCircle';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';

import bNavItem from 'bootstrap-vue/es/components/nav/nav-item';
import bNavText from 'bootstrap-vue/es/components/nav/nav-text';
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav';

@Component({
  components: {
    FontAwesomeIcon,

    bNavItem,
    bNavText,
    bNavbarNav,
  },
})
export default class TopHeader extends Vue {
  public readonly faFacebookSquare = faFacebookSquare;
  public readonly faInstagram = faInstagram;
  public readonly faLine = faLine;
  public readonly faPhone = faPhone;
  public readonly faQuestionCircle = faQuestionCircle;
}

